import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1)
const _hoisted_5 = { class: "DialogSection" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_7 = { class: "DialogSection" }
const _hoisted_8 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_9 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesImageInput = _resolveComponent("CookiesImageInput")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Saving)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.Loading.length > 0)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_CookiesImageInput, {
              Folder: 'Catalogs',
              Res: 'D_Catalog_Image',
              style: {"border-radius":"var(--rad1)","width":"80%","height":"12em"}
            })
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_CookiesNormalInput, {
              Placeholder: _ctx.Translate('Catalog Name'),
              CookiesInvalidInput: !(_ctx.MEMRead('D_Catalog_Name') && _ctx.MEMRead('D_Catalog_Name') !== ''),
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Catalog_Name') && _ctx.MEMRead('D_Catalog_Name') !== ''),
              Res: 'D_Catalog_Name',
              Default: ''
            }, null, 8, ["Placeholder", "CookiesInvalidInput", "ErrorData"]),
            _createVNode(_component_CookiesDescriptionBox, {
              Placeholder: _ctx.Translate('Description'),
              Res: 'D_Catalog_Description'
            }, null, 8, ["Placeholder"])
          ])
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access(_ctx.DialogData.Editing ? 'Catalogue_Edit': 'Catalogue_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main),
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Save')), 5)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}